<template>
  <div id="app">
    <router-view />
    <!--#region Loading-->
    <div v-if="loading" class="position-fixed bg-gray-950 row justify-content-center align-content-center"
         style="left: 0; right: 0; top: 0; bottom: 0; z-index: 1051; opacity: 0.7;">
      <div class="col-auto d-flex">
        <div class="text-white h1 align-self-center"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
      </div>
    </div>
    <!--#endregion-->
    <!--#region Message Box-->
    <!--#endregion-->
  </div>
</template>

<script>
  import Vue from 'vue';
  import  { safeHtml } from '@/helpers/vue-safehtml'
  export default {
    name: "App",
    data: () => {
      return {
        loadingCount: 0
      };
    },
    computed: {
      loading() {
        if (this.loadingCount < 0) {
          this.loadingCount = 0;
        }
        return this.loadingCount > 0;
      }
    },
    created: function () {
      let self = this;

      //#region -- axios Default Setups / Error Handler --
      self.$axios.defaults.timeout = 150000; // 90000

      self.$axios.interceptors.response.use(
        response => {
          return response;
        },
        err => {
          if (err && err.response) {
            switch (err.response.status) {
              case 401:
                console.log('expired token')
                let frontEndUrl = self.$session.get('frontEndUrlToUse');
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                const url = new URL(window.location.href);

                // 提取路径、查询参数和哈希
                const fullPath = url.pathname + url.search + url.hash;
                self.$axios.get(url)
                  .then((res) => { })
                window.location.href = `${frontEndUrl.slice(0, -1)}${fullPath}`;
              case 404:
                console.log("找不到該頁面");
                break;
              case 500:
                console.log("伺服器出錯");
                break;
              case 503:
                console.log("服務失效");
                break;
              default:
                console.log(`連接錯誤${err.response.status}`);
            }
            console.log(err.response);
            self.$message.exception(_.get(err.response.data, 'description', 'Unknown Error'));

          } else {
            console.log("連接到服務器失敗");
          }
          return Promise.resolve(err.response);
        }
      );

      //#endregion -- axios Error Handler --

      //#region -- Loading --
      eventHub.$on('loading', function (bln) {
        //console.log(`[BEFORE] self.loadingCount =`);
        //console.log(self.loadingCount);
        self.loadingCount = self.loadingCount + (bln ? 1 : -1);
        //console.log(`[AFTER] self.loadingCount =`);
        //console.log(self.loadingCount);
      });
      //#endregion

      //#region -- Message Box --

      let fnShowMessage = (title, message, variant) => {
        const h = this.$createElement;
        const titleVNode = h('div', { class: ['font-weight-bold'], domProps: { innerHTML: safeHtml(title) } });
        const messageVNode = h('pre', { class: ['text-break', 'mb-0'], style: { 'white-space': 'pre-wrap' } }, [message]);

        let noCloseOnBackdrop = variant === 'danger';

        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          headerClass: 'pb-0 border-bottom-0 text-' + (variant || 'primary'),
          bodyClass: 'py-1',
          footerClass: 'pt-0 border-top-0',
          centered: true,
          hideHeaderClose: false,
          noCloseOnBackdrop: noCloseOnBackdrop,
          okVariant: variant || 'primary'
        })
      };

      eventHub.$on('showMessage', fnShowMessage);

      let fnShowMessageHtml = (title, message, variant) => {
        const h = this.$createElement;
        const titleVNode = h('div', { class: ['font-weight-bold'], domProps: { innerHTML: safeHtml(title) } });
        const messageVNode = h('div', {
          class: ['text-break', 'mb-0'],
          style: { 'white-space': 'pre-wrap' },
          domProps: { innerHTML: safeHtml(message) }
        });

        let noCloseOnBackdrop = variant === 'danger';

        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          headerClass: 'pb-0 border-bottom-0 text-' + (variant || 'primary'),
          bodyClass: 'py-1',
          footerClass: 'pt-0 border-top-0',
          centered: true,
          hideHeaderClose: false,
          noCloseOnBackdrop: noCloseOnBackdrop,
          okVariant: variant || 'primary'
        })
      };

      eventHub.$on('showMessageHtml', fnShowMessageHtml);

      const Message = (options) => { };
      Message.success = (msg, title) => {
        fnShowMessage(title, msg, 'success');
      };
      Message.warning = (msg, title) => {
        fnShowMessage(title, msg, 'warning');
      };
      Message.info = (msg, title) => {
        fnShowMessage(title, msg, 'info');
      };
      Message.error = (msg, title) => {
        fnShowMessage(title, msg, 'danger');
      };

      Message.exception = (msg) => {
        fnShowMessage('Exception', msg, 'danger');
      };

      Vue.prototype.$message = Message;

      //#endregion

    }
  };
</script>



// WEBPACK FOOTER //
// src/App.vue